/**
 * Format cents as a dollar string (e.g. 5000 → "$50.00").
 * @param {number|null} cents
 * @returns {string}
 */
export function formatCents(cents) {
    if (cents == null) return '-';
    return `$${(cents / 100).toFixed(2)}`;
}

/**
 * Format an ISO date string as a short localized date (e.g. "Mar 28, 2026").
 * @param {string} dateStr
 * @returns {string}
 */
export function formatMediumDate(dateStr) {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

/**
 * Trigger a browser download of a markdown string as a .md file.
 * @param {string} filename
 * @param {string} content
 */
export function downloadMarkdown(filename, content) {
    const blob = new Blob([content], { type: 'text/markdown' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
}

/**
 * Convert a 1-based version number to a letter label (1→A, 2→B, …, 27→AA).
 * @param {number} version
 * @returns {string}
 */
export function versionLabel(version) {
    let label = '';
    let v = version;
    while (v > 0) {
        v--;
        label = String.fromCharCode(65 + (v % 26)) + label;
        v = Math.floor(v / 26);
    }
    return label;
}

/**
 * Format an asset size label, with grid dimensions for tactical maps.
 * @param {string} assetType
 * @param {string} size - miniature: 'T','S','M','L','H','G'; tactical-map: 'S','M','L'
 * @returns {string}
 */
export function sizeLabel(assetType, size) {
    if (assetType === 'tactical-map') {
        const grids = { S: 'Small (12x12)', M: 'Medium (24x24)', L: 'Large (48x48)' };
        return grids[size] || size;
    }
    const names = { T: 'Tiny', S: 'Small', M: 'Medium', L: 'Large', H: 'Huge', G: 'Gargantuan' };
    return names[size] || size;
}

/**
 * Convert a phase type slug to a display name.
 * @param {string} type
 * @returns {string}
 */
export function phaseDisplayName(type) {
    switch (type) {
        case 'composition':
            return 'Composition';
        case 'line-art':
            return 'Line Art';
        case 'sketch':
            return 'Sketch';
        case 'color-rough':
            return 'Color Rough';
        case 'final-render':
            return 'Final Render';
        case 'delivery':
            return 'Delivery';
        default:
            return type;
    }
}
